import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgTravellerCrossed = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <mask id="travellerCrossed_svg__a">
          <rect width="100%" height="100%" fill="#fff" />
          <rect width={20} height={20} x={32} y={32} rx={10} />
        </mask>
      </defs>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M33.335 16.667a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M36.665 30.833c0-3.143 0-4.714-.976-5.69-.976-.977-2.548-.977-5.69-.977s-4.714 0-5.69.976c-.977.977-.977 2.548-.977 5.69v2.5c0 1.572 0 2.358.488 2.846s1.274.488 2.845.488v6.667c0 1.571 0 2.357.489 2.845.488.488 1.273.488 2.845.488 1.571 0 2.357 0 2.845-.488s.488-1.274.488-2.845v-6.667c1.571 0 2.357 0 2.845-.488s.488-1.274.488-2.845z"
        mask="url(#travellerCrossed_svg__a)"
      />
      <path
        stroke="#DE370C"
        strokeLinecap="round"
        strokeWidth={2}
        d="m46 38-8 8m8 0-8-8"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgTravellerCrossed);
export default Memo;
